import { Component } from '@angular/core';
import { IconBase } from 'src/app/icons/icon.base';
import { IconConfig } from 'src/app/icons/icon.config';

@Component({
  selector: 'fit-tools-shovel-icon',
  templateUrl: './tools-shovel.component.html'
})
export class ToolsShovelComponent extends IconBase {

  constructor(config?: IconConfig) {
    super(config);
  }
}
